import { FormGetters } from "./types";

const formGetters: FormGetters = {};

export { formGetters };
